import React, {useEffect} from "react";
import {useStore} from "../../../../../../../hooks/useStore";
import {useFetch} from "../../../../../../../hooks/useFetch";
import {Popover, Table, Typography} from "antd";
import moment from "moment";
import {formatMoney} from "../../../../../../../utils/moneyHelper";
import JSONInput from "react-json-editor-ajrm";
import {InfoCircleOutlined} from "@ant-design/icons";
import {isNumber} from "lodash";
const {Text} = Typography;
export const WalletTransactions = ({externalId, dailyTransactionId}) => {
    const stores = useStore();
    const [transactionsResultLoading, transactionsResult] = useFetch({
        defaultDataValue: {},

        fetchFn: stores.walletStore.getDailyTransactions.bind(null, {
            courierId: externalId,
            dailyTransactionId: dailyTransactionId
        }),
        initialCall: true,
        condition: !!externalId && !!dailyTransactionId
    });

    return (
        <Table
            rowKey="_id"
            columns={[
                {
                    title: "İşlem Türü",
                    dataIndex: "humanReadableType",
                    key: "humanReadableType",
                    sorter: (a, b) => {
                        return a.humanReadableType.localeCompare(b.humanReadableType);
                    },
                    sortDirections: ["descend", "ascend"],
                    render: (humanReadableType, record) => {
                        return humanReadableType
                            ? humanReadableType
                            : `{${record?.type} - ${record?.reason}}`;
                    }
                },
                {
                    title: "İşlem Tutarı",
                    dataIndex: "amount",
                    key: "amount",
                    sorter: (a, b) => {
                        return a.amount - b.amount;
                    },
                    sortDirections: ["descend", "ascend"],
                    render: amount => {
                        return (
                            <Text type={amount >= 0 ? "success" : "danger"} strong>
                                {formatMoney({amount})}
                            </Text>
                        );
                    }
                },
                {
                    title: "İşlem Tarihi",
                    dataIndex: "createdAt",
                    key: "createdAtDate",
                    sorter: (a, b) => {
                        return moment(a.createdAt).diff(moment(b.createdAt));
                    },
                    sortDirections: ["descend", "ascend"],
                    render: createdAt => {
                        return createdAt ? moment(createdAt).format("DD.MM.YYYY") : "";
                    }
                },
                {
                    title: "İşlem Saati",
                    dataIndex: "createdAt",
                    key: "createdAtTime",
                    sorter: (a, b) => {
                        return moment(a.createdAt).diff(moment(b.createdAt));
                    },
                    sortDirections: ["descend", "ascend"],
                    render: createdAt => {
                        return createdAt ? moment(createdAt).format("HH:mm") : "";
                    }
                },
                {
                    title: "Detay",
                    dataIndex: "metaData",
                    key: "metaData",
                    render: metaData => {
                        return metaData ? (
                            <Popover
                                content={
                                    <JSONInput
                                        id="courierLogGPSProviderJSON"
                                        placeholder={metaData}
                                        theme="dark_mitsuketa_tribute"
                                        width="auto"
                                        height="auto"
                                        viewOnly={true}
                                        confirmGood={false}
                                    />
                                }
                            >
                                <InfoCircleOutlined style={{marginLeft: "5px"}} />
                            </Popover>
                        ) : (
                            <></>
                        );
                    }
                }
            ]}
            dataSource={transactionsResult?.data?.transactions || []}
        />
    );
};
